import Router from 'next/router';
import { CHECKOUT_ROUTE, STEPS } from '@/constants/checkout';
import { PAGES } from '@/constants/pages';

export const prevStep = (checkout) => {
  switchStep(getPrevStep(checkout).url);
};

export const nextStep = (checkout, cart) => {
  if (checkout.current.id === findStepByUrl(checkout, STEPS.SHIPPING_ADDRESS).id &&
    cart.shipping?.idNext === cart.billing?.idNext) {
    switchStep(STEPS.SHIPPING_MODE);
    return;
  }
  switchStep(getNextStep(checkout).url);
};

export const switchStep = (step, code) => {
  Router.push(CHECKOUT_ROUTE, `${PAGES.CHECKOUT}/${step}${code ? `?code=${code}` : ''}`);
};

export const switchStepWithReturn = (step, retStep) => {
  Router.push(CHECKOUT_ROUTE, `${PAGES.CHECKOUT}/${step}${retStep ? `?continue=${retStep}` : ''}`);
};

export const switchStepWithErrorAddressParam = (step) => {
  Router.push(CHECKOUT_ROUTE, `${PAGES.CHECKOUT}/${step}?errorAddress=true`);
};

export const findStepByUrl = (checkout, url) => checkout.steps.find((step) => step.url === url);
export const findStepById = (checkout, id) => checkout.steps.find((step) => step.id === id);
export const getNextStep = (checkout) => findStepById(checkout, checkout.current.id + 1);
export const getPrevStep = (checkout) => findStepById(checkout, checkout.current.id - 1);

export const getStepWithParams = (step, code, defaultMessage) => {
  let param = '';

  if (code) {
    param += `?code=${code}`;

    if (defaultMessage) {
      param += `&defaultMessage=${defaultMessage}`;
    }
  }

  return `${step}${param}`;
};
